import { createSelector } from 'reselect'
import { RootState } from '../../../store/rootState'
import { IProjectBudgetCost } from '../types/costs'

export const getBudgetCostsState = (state: RootState): IProjectBudgetCost[] => state.projectsState.budgetCosts
const getSearchBudgetCosts = (state: RootState) => state.projectsState.searchActivities

export const getBudgetCostsSelector = createSelector(
  [getBudgetCostsState, getSearchBudgetCosts],
  (budgetCosts, { search }) => {
    return search
      ? budgetCosts.filter(({ position }) => position.toLowerCase().includes(search.toLowerCase()))
      : budgetCosts
  }
)
